import { useEffect, useState } from "react";
import type { VideoItem } from "@/types/video";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  video: VideoItem;
}

export default function DetailActions({ video }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");

  const favorited = isFavorite(video.id);

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleFavorite = () => {
    toggleFavorite(video.id);
    setToast(favorited ? "已取消收藏" : "收藏成功");
  };

  const handleShare = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
    }
  };

  return (
    <div className="relative flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={handleFavorite}
        className={
          favorited
            ? "flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            : "flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
        }
      >
        <i className={favorited ? "ri-heart-3-fill" : "ri-heart-3-line"} />
        {favorited ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={handleShare}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
      >
        <i className="ri-share-line" />
        分享
      </button>

      {toast && (
        <span className="absolute -top-11 left-0 rounded-md bg-foreground-950 px-3 py-1.5 text-xs font-medium text-background-50 md:left-auto">
          {toast}
        </span>
      )}
    </div>
  );
}